<template>
    <!-- *********************************************
    *                Identification Data             *
    ********************************************** -->
    <divider-generic icon="id" :title="t('join.createAccount.step7.identificationDataTitle')" :applyBorder="false"/>
    <!-- BI upload info -->
    <text-block-generic
    icon="check-circle"
    colorIcon="var(--positive)"
    :params="{ label: t('join.createAccount.step7.BILabel'), content: t('join.createAccount.step7.BIContent') }"/>
    <!-- Identification Card Number -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.idCardNumber'), content: formData.idCardNumber }"/>
    <!-- Identification Card Emission Date -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.idCardEmissionDate'), content: getDate(formData.idCardEmissionDate) }"/>
    <!-- Identification Card Expiration Date -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.idCardExpirationDate'), content: getDate(formData.idCardExpirationDate) }"/>
    <!-- Birth Date -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.birthDate'), content: getDate(formData.birthDate) }"/>
    <!-- *********************************************
    *                   Personal Data                *
    ********************************************** -->
    <divider-generic icon="identification" :title="t('join.createAccount.step7.personalTitle')"/>
    <!-- Name On Id Card -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.nameOnIdCard'), content: formData.nameOnIdCard }"/>
    <!-- Father Name -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.fatherName'), content: formData.fatherName }"/>
    <!-- Mother Name -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.motherName'), content: formData.motherName }"/>
    <!-- Marital Status -->
    <text-block-generic
    :params="{ label: t('join.createAccount.step7.maritalStatus'), content: getMaritalStatus.find(obj => obj.maritalStatus === formData.maritalStatus).description }"/>
    <!-- Birth Location -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.birthLocationProvince'), content: formData.birthLocationProvince }"/>
    <!-- Gender -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.gender'), content: t(`join.createAccount.step7.gender${formData.gender}`) }"/>
    <!-- Address -->
    <text-block-generic :params="{ label: t('join.createAccount.step7.address'), content: formData.address }"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue & Assets */
import { getDate } from '@/assets/scripts/dateBuilders'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** Props
@formData {Object} - Object with form data
*/
const props = defineProps({
    formData: Object
})

const { getMaritalStatus } = mapGetters(moduleMapper.JOIN_CREATE_ACCOUNT)
</script>

<style lang="scss" scoped>
</style>
